/* Openplay.ie — vanilla JS behaviours for Shopify Dawn sections.
   Self-contained, no dependencies except Leaflet (loaded separately on map pages). */

(function () {
  'use strict';

  // ========== 1. Filter group expand/collapse ==========
  function initFilterGroups(root) {
    (root || document).querySelectorAll('.op-filter-group').forEach(function (group) {
      var head = group.querySelector('.op-filter-group__head');
      if (!head) return;
      head.addEventListener('click', function () {
        var open = group.getAttribute('aria-expanded') === 'true';
        group.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });
  }

  // ========== 2. Sticky buy bar on PDP ==========
  function initStickyBuy() {
    var bar = document.querySelector('.op-sticky-buy');
    if (!bar) return;
    var onScroll = function () {
      if (window.scrollY > 800) bar.classList.add('is-visible');
      else bar.classList.remove('is-visible');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ========== 3. PDP gallery thumb switcher + zoom lightbox ==========
  function initPDPGallery() {
    var gallery = document.querySelector('[data-op-gallery]');
    if (!gallery) return;
    var thumbs = gallery.querySelectorAll('[data-thumb]');
    var main   = gallery.querySelector('[data-main-img]');
    var viewLabel = gallery.querySelector('[data-view-label]');
    var total  = thumbs.length;
    var active = 0;

    function select(i) {
      if (i < 0 || i >= total) return;
      active = i;
      thumbs.forEach(function (t, idx) {
        t.classList.toggle('is-active', idx === i);
      });
      var src = thumbs[i].getAttribute('data-full') || thumbs[i].querySelector('img') && thumbs[i].querySelector('img').src;
      if (main && src) main.setAttribute('src', src);
      if (viewLabel) {
        var label = thumbs[i].getAttribute('data-label') || '';
        viewLabel.textContent = 'View ' + String(i + 1).padStart(2, '0') + ' / ' + String(total).padStart(2, '0') + (label ? ' · ' + label : '');
      }
    }

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i); });
    });

    var prev = gallery.querySelector('[data-prev]');
    var next = gallery.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { select(Math.max(0, active - 1)); });
    if (next) next.addEventListener('click', function () { select(Math.min(total - 1, active + 1)); });

    // Zoom
    var zoomBtn   = gallery.querySelector('[data-zoom-open]');
    var zoomLayer = document.querySelector('[data-op-zoom]');
    var zoomImg   = zoomLayer && zoomLayer.querySelector('img');
    if (zoomBtn && zoomLayer) {
      zoomBtn.addEventListener('click', function () {
        if (zoomImg && main) zoomImg.setAttribute('src', main.getAttribute('src') || '');
        zoomLayer.classList.add('is-open');
      });
      zoomLayer.addEventListener('click', function () { zoomLayer.classList.remove('is-open'); });
    }
  }

  // ========== 4. PDP weight / colour swatches (visual only) ==========
  function initPDPVisualSelectors() {
    document.querySelectorAll('[data-op-visual-group]').forEach(function (group) {
      var btns = group.querySelectorAll('[data-op-visual-btn]');
      btns.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          btns.forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          var display = group.querySelector('[data-op-visual-value]');
          var label = btn.getAttribute('data-label') || btn.textContent.trim();
          if (display) display.textContent = label;
        });
      });
    });
  }

  // ========== 5. PDP add-ons running total ==========
  function initAddOnTotals() {
    var form = document.querySelector('[data-op-pdp-form]');
    if (!form) return;
    var basePriceEl = form.querySelector('[data-op-base-price]');
    var totalEl     = form.querySelector('[data-op-total]');
    if (!basePriceEl || !totalEl) return;
    var base = parseFloat(basePriceEl.getAttribute('data-value') || '0');

    function recalc() {
      var total = base;
      form.querySelectorAll('.op-addon input[type="checkbox"]:checked').forEach(function (cb) {
        total += parseFloat(cb.value || '0');
      });
      var qtyEl = form.querySelector('[name="quantity"]');
      var qty = qtyEl ? Math.max(1, parseInt(qtyEl.value, 10) || 1) : 1;
      total = base * qty + (total - base);
      totalEl.textContent = '€' + total.toFixed(2).replace(/\.00$/, '');
    }
    form.addEventListener('change', recalc);
    form.addEventListener('input', recalc);
    recalc();
  }

  // ========== 6. Quantity stepper ==========
  function initQty() {
    document.querySelectorAll('[data-op-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      var minus = wrap.querySelector('[data-qty-minus]');
      var plus  = wrap.querySelector('[data-qty-plus]');
      if (!input) return;
      if (minus) minus.addEventListener('click', function (e) {
        e.preventDefault();
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      if (plus) plus.addEventListener('click', function (e) {
        e.preventDefault();
        input.value = (parseInt(input.value, 10) || 1) + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  // ========== 7. Quick-pill filter row (PLP) ==========
  // Links already point to filtered URLs; JS just marks active from current URL.
  function initQuickPills() {
    document.querySelectorAll('[data-op-quickpills]').forEach(function (row) {
      var here = location.pathname + location.search;
      row.querySelectorAll('a').forEach(function (a) {
        var href = a.getAttribute('href') || '';
        if (href && (here === href || here.indexOf(href.split('?')[1] ? href.split('?')[1] : '__NA__') > -1)) {
          a.classList.add('op-pill--active');
        }
      });
    });
  }

  // ========== 8. Leaflet court map + searchable sidebar ==========
  function initCourtMap() {
    var el = document.getElementById('op-map');
    if (!el) return;
    if (typeof L === 'undefined') { console.warn('Leaflet not loaded'); return; }

    var lat     = parseFloat(el.getAttribute('data-lat'))  || 53.35;
    var lng     = parseFloat(el.getAttribute('data-lng'))  || -7.9;
    var zoom    = parseFloat(el.getAttribute('data-zoom')) || 6.8;
    var tiles   = el.getAttribute('data-tiles') || 'carto';
    var flyZoom = parseFloat(el.getAttribute('data-fly-zoom')) || 13;
    var data    = [];
    try { data = JSON.parse(el.getAttribute('data-courts') || '[]'); } catch (e) { data = []; }

    var map = L.map(el, { scrollWheelZoom: false, zoomControl: true }).setView([lat, lng], zoom);

    var tileUrl, tileAttr;
    if (tiles === 'osm') {
      tileUrl  = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
      tileAttr = '&copy; OpenStreetMap contributors';
    } else {
      // tileUrl  = 'https://{s}.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}{r}.png';
      // tileAttr = '&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a> &copy; <a href="https://carto.com/attributions">CARTO</a>';
       tileUrl  = 'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}';
      tileAttr = 'Tiles &copy; <a href="https://www.esri.com/">Esri</a>';
    }
    L.tileLayer(tileUrl, { attribution: tileAttr, maxZoom: 18 }).addTo(map);

    // var pinIcon = L.divIcon({
    //   className: 'op-map__pin-wrap',
    //   html: '<div class="op-map__pin"></div>',
    //   iconSize: [18, 18],
    //   iconAnchor: [9, 9],
    // });
    var pinIcon = L.icon({
    iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
    shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    });

    var markers = {};
    data.forEach(function (c, i) {
      if (typeof c.lat !== 'number' || typeof c.lng !== 'number') return;
      if (c.lat === 0 && c.lng === 0) return;
      var marker = L.marker([c.lat, c.lng], { icon: pinIcon }).addTo(map);
      var html = ''
        + '<div class="op-popup">'
        + (c.county ? '<div class="op-popup__kicker">' + escapeHtml(c.county) + '</div>' : '')
        + '<div class="op-popup__name">' + escapeHtml(c.name || '') + '</div>'
        + '<div class="op-popup__meta">'
          + (c.indoor_outdoor ? escapeHtml(c.indoor_outdoor) : '')
          + (c.courts_count ? ' · ' + c.courts_count + ' courts' : '')
          + (c.surface ? ' · ' + escapeHtml(c.surface) : '')
        + '</div>'
        + (c.url ? '<a href="' + encodeURI(c.url) + '" class="op-popup__cta">Book →</a>' : '')
        + '</div>';
      marker.bindPopup(html);
      markers[i] = marker;
    });

    // ========== Sidebar list + search ==========
    var listEl = document.getElementById('op-map-list');
    var searchEl = document.getElementById('op-map-search-input');
    var countEl = document.getElementById('op-map-count');

    function renderList(q) {
      if (!listEl) return;
      var query = (q || '').trim().toLowerCase();
      var html = '';
      var shown = 0;
      data.forEach(function (c, i) {
        if (typeof c.lat !== 'number' || typeof c.lng !== 'number') return;
        if (c.lat === 0 && c.lng === 0) return;
        if (query) {
          var hay = ((c.name || '') + ' ' + (c.county || '') + ' ' + (c.indoor_outdoor || '')).toLowerCase();
          if (hay.indexOf(query) === -1) return;
        }
        shown++;
        html += '<button type="button" class="op-map-item" role="listitem" data-idx="' + i + '">'
          +   '<div class="op-map-item__name">' + escapeHtml(c.name || '') + '</div>'
          +   '<div class="op-map-item__meta">'
          +     (c.county ? escapeHtml(c.county) : '')
          +     (c.courts_count ? (c.county ? ' · ' : '') + c.courts_count + ' courts' : '')
          +     (c.indoor_outdoor ? ' · ' + escapeHtml(c.indoor_outdoor) : '')
          +   '</div>'
          + '</button>';
      });
      listEl.innerHTML = html || '<div class="op-map-empty">No courts match "' + escapeHtml(query) + '".</div>';
      if (countEl) countEl.textContent = shown;
    }

    if (listEl) {
      listEl.addEventListener('click', function (e) {
        var btn = e.target.closest('.op-map-item');
        if (!btn) return;
        var idx = parseInt(btn.getAttribute('data-idx'), 10);
        var c = data[idx];
        if (!c || typeof c.lat !== 'number' || typeof c.lng !== 'number') return;
        map.flyTo([c.lat, c.lng], flyZoom, { duration: 1.1 });
        var marker = markers[idx];
        if (marker) {
          setTimeout(function () { marker.openPopup(); }, 1150);
        }
        listEl.querySelectorAll('.op-map-item').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    }

    if (searchEl) {
      var t = null;
      searchEl.addEventListener('input', function (e) {
        var v = e.target.value;
        clearTimeout(t);
        t = setTimeout(function () { renderList(v); }, 120);
      });
    }

    renderList('');
  }

  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // ========== 9. Init ==========
  function init() {
    initFilterGroups(document);
    initStickyBuy();
    initPDPGallery();
    initPDPVisualSelectors();
    initAddOnTotals();
    initQty();
    initQuickPills();
    initCourtMap();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init for Shopify theme editor section reloads
  document.addEventListener('shopify:section:load', function () {
    init();
  });
})();
